import styled from "styled-components";

const SupportContactUsStyles = styled.div`
  .header-container {
    max-height: 600px;
  }  

  .page-title {
    display: none;

    ${props => props.theme.media.lg} {
      display: block;
      font-family: 'Poppins';
      font-style: normal;
      font-weight: 400;
      font-size: 36px;
      line-height: 48px;
      color: rgba(18, 23, 36, 0.91);
      margin-top: 16px;
    }
  }

  .header-background {
    display: flex;
    flex-direction: column;
    margin-top: -7rem;

    ${props => props.theme.media.lg} {
      display: block;
      max-height: 500px;
      margin-top: 0px;
    }
  }

  .brown-background {
    position: relative;
    top: 10rem;
    background-color: #EFE7DA;
    text-align: center;
    padding-top: 40px;
    overflow: visible;
    border-radius: 16px;

    ${props => props.theme.media.lg} {
      top: 2rem;
    }
  }

  .header-image {
    margin-top: -6rem;

    ${props => props.theme.media.lg} {
      margin-top: -5rem;
    }
  }

  .header-details {
    z-index: 1;
    background: rgba(219, 212, 200, 0.8);
    backdrop-filter: blur(40px);
    border-radius: 16px;
    min-height: 260px;
    text-align: center;
    position: relative;
    bottom: 90px;

    ${props => props.theme.media.lg} {
      min-height: 198px;
      bottom: 10rem;
      padding-top: 10px;
    }

    .header {
      background: #EFE7DA;
      border-radius: 9px;
      font-size: 12px;
      font-weight: 700;
      line-height: 16px;
      letter-spacing: 4.5%;
      padding: 8px 16px;
      width: 161px;
      margin: auto;
      margin-top: 24px;
      margin-bottom: 16px;
    }

    .header-title {
      font-family: Poppins;
      font-size: 24px;
      font-weight: 500;
      line-height: 150%;
      letter-spacing: 0.0075em;
      text-align: center;
      color: rgba(18, 23, 36, 0.91);
      margin-bottom: 16px;
    }

    .btn {
      font-family: Poppins;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: 0.02em;
      text-align: left;
      width: 90%;
      height: 42px;
      margin-bottom: 16px;
      letter-spacing: 0.02em;

      ${props => props.theme.media.lg} {
        width: 203px;
        margin: 0px 8px;
      }
    }

    .message-btn:before {
      content: url("/icons/support-send.svg");
      position: relative;
      top: 2px;
      right: 9px;

      ${props => props.theme.media.lg} {
        right: 5px;
        top: 3px;
      }
    }

    .call-btn:before {
      content: url("/icons/support-schedule.svg");
      position: relative;
      top: 2px;
      right: 9px;

      ${props => props.theme.media.lg} {
        right: 5px;
      }
    }
  }

  .info-container {
    padding: 0px 16px;

    ${props => props.theme.media.lg} {
      margin-bottom: 151px;
    }

    .info-header {
      text-align: center;
      font-family: 'Poppins';
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 36px;
      text-align: center;
      letter-spacing: 0.0075em;
      color: rgba(18, 23, 36, 0.91);
      margin-bottom: 16px;
    }

    .icons-container {
      ${props => props.theme.media.lg} {
        display: grid;
        grid-template-columns: repeat(1fr, 3);
        grid-gap: 24px;
      }

      .icon:last-child {
        ${props => props.theme.media.lg} {
          grid-column: span 3;
          width: 100%;
        }
      }
      .icon {
        display: flex;
        align-items: center;
        margin: auto;
        border: 1px solid rgba(18, 23, 36, 0.2);
        box-shadow: 0px 4px 24px rgba(229, 229, 229, 0.5);
        border-radius: 8px;
        width: 100%;
        height: 72px; 
        margin-bottom: 16px;
        cursor: pointer;

        ${props => props.theme.media.lg} {
          flex-direction: column;
          height: 155px;
          width: 250px;
          padding: 16px;
        }

        .icon-image {
          margin: 16px;

          img {
            ${props => props.theme.media.lg} {
              position: relative;
              top: calc(50% - 25px);
            }
          }
        }

        .icon-title {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          letter-spacing: 0.01em;
          color: rgba(18, 23, 36, 0.91);

          ${props => props.theme.media.lg} {
            text-align: center;
          }
        }

        .open.icon-description {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.01em;
          color: rgba(18, 23, 36, 0.65);
          position: relative;
          left: 5px;

          ${props => props.theme.media.lg} {
            max-width: 168px;
            text-align: center;
          }
        }

        .open.icon-description::before {
          display:inline-block;
          content: "";
          width: 8px;
          height: 8px;
          background: #11AB7D;
          border-radius: 50%;
          position: relative;
          right: 5px;
        }

        .closed.icon-title {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.01em;
          color: rgba(18, 23, 36, 0.65);
        }

        .closed.icon-description {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          line-height: 20px;
          letter-spacing: 0.01em;
          color: rgba(18, 23, 36, 0.91);
          max-width: 255px;

          ${props => props.theme.media.lg} {
            text-align: center;
          }
        }
      }

      .schedule-icon {
        .icon-text-container {
          max-width: 255px;

          ${props => props.theme.media.sm} {
            max-width: 100%;
          }
        }
      }

      .email-icon {
        height: 152px;

        ${props => props.theme.media.lg} {
          height: 100%;
        }

        .email-text-container {
          ${props => props.theme.media.lg} {
            width: 100%;
          }
        }

        .icon-image {
          position: relative;

          img {
            position: relative;
            bottom: 36px;

            ${props => props.theme.media.lg} {
              position: initial;
            }
          }
        }

        .icon-text-container {
          ${props => props.theme.media.lg} {
            display: flex;
            width: 100%;
            justify-content: space-around;
            margin-top: 24px;
            padding-top: 24px;
            border-top: 1px solid rgba(18, 23, 36, 0.2);
          }
        }

        .icon-description {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.01em;
          color: rgba(18, 23, 36, 0.65);
          margin-bottom: 0px;
        }

        .partnerships {
          margin-top: 16px;

          ${props => props.theme.media.lg} {
            margin-top: initial;
          }
        }

        .icon-link {
          display: flex;
          a {
            font-family: 'Poppins';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: 0.01em;
            text-decoration-line: underline;
            color: #1776B6;

            ${props => props.theme.media.lg} {
              font-size: 16px;
              font-weight: 400;
            }
          }
        }
      }
    }
  }
`;

export default SupportContactUsStyles;